import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(form.email.trim(), form.password);
      toast.success(`Welcome back, ${u.first_name}!`);
      nav(`/${u.role}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-2xl font-extrabold text-slate-900 block mb-8">
          Shift<span className="text-blue-600">Flex</span>
        </Link>
        <div className="bg-white border border-slate-200 rounded-md p-8">
          <h1 className="font-display text-3xl font-extrabold text-slate-900 mb-1">Welcome back</h1>
          <p className="text-slate-600 mb-6">Log in to continue.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="label-caps">Email</Label>
              <Input data-testid="login-email-input" id="email" type="email" required autoComplete="email"
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="h-12 mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password" className="label-caps">Password</Label>
              <Input data-testid="login-password-input" id="password" type="password" required autoComplete="current-password"
                value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="h-12 mt-1.5" />
            </div>
            <Button data-testid="login-submit-btn" type="submit" disabled={busy}
              className="w-full h-12 bg-blue-600 hover:bg-blue-700 rounded-md font-semibold text-base">
              {busy ? "Signing in…" : "Log in"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-slate-600 flex items-center justify-between gap-4">
            <Link to="/forgot-password" data-testid="link-forgot-password" className="text-blue-600 font-semibold">
              Forgot password?
            </Link>
            <span>No account? <Link to="/register" data-testid="link-to-register" className="text-blue-600 font-semibold">Sign up</Link></span>
          </div>
        </div>
      </div>
    </div>
  );
}
